var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height"},[_c('StripeElementCard',{ref:"stripeRef",staticClass:"mt-4 mb-8",style:({
      borderColor: 'red',
    }),attrs:{"pk":_vm.publishableKey,"hidePostalCode":""}}),_c('v-btn',{attrs:{"color":_vm.colorFromEvent,"elevation":"4","text":"","disabled":_vm.loading,"rounded":"","block":""},on:{"click":_vm.submitPayment}},[_vm._v("Confirm")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }